<template>
  <div>
    <p class="ma-0 font-weight-medium">
      {{coluna.texto}}
    </p>

    <p class="ma-0 mt-n1">
      <template v-if="detalhamento_categoria.ressuprimento_em_dias !== '-'">
        {{`${Helpers.formatarValor(detalhamento_categoria.ressuprimento_em_dias)} dias`}}
        <v-icon small class="mt-n1" @click="dialog_ativo = true">mdi-pencil</v-icon>
      </template>
      <template v-else>-</template>
    </p>

    <v-dialog
      v-model="dialog_ativo"
      width="500"
      content-class="bra-20"
      transition="dialog-top-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5 lighten-2">
          <span>Ressuprimento</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog_ativo = false">
          <v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="mt-5">
          <SysCategoriaMPPA
            v-model="categorias_selecionadas"
            label="Categorias onde a edição será feita"
            :qtde_visivel_selecionados="1"
            outlined
            clearable
            multiple
            :error-messages="getMensagensValidacao('categorias_selecionadas')"
          />

          <TextFieldFormatadorDeValor
            v-model="ressuprimento"
            outlined
            label="Ressuprimento"
            suffix="dias"
            inteiro
            :max-digitos="0"
            :error-messages="getMensagensValidacao('ressuprimento')"
            @focus="$event.target.select()"
            @keypress.enter="alterarTempoRessuprimento()"
          />
        </v-card-text>

        <v-card-actions class="mt-n6">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="alterarTempoRessuprimento()"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import { required, minValue } from "vuelidate/lib/validators";
import { logout } from '@/helpers';
import { alterarTempoRessuprimento } from '@/api/compras/MateriaPrima';
import TextFieldFormatadorDeValor from '../../../../../utils/TextFieldFormatadorDeValor.vue';
import {categoria_selecionada} from "@/components/compra/materiaPrima/compra/Helpers/CategoriaSelecionado";
import {mapGetters} from "vuex";
import SysCategoriaMPPA from "@/components/utils/crud/SysCategoriaMPPAAutocomplete";

export default {
  name: "Ressuprimento",
  mixins: [categoria_selecionada],
  components: {
    SysCategoriaMPPA,
    TextFieldFormatadorDeValor,
  },
  props: {
    coluna: Object,
    detalhamento_categoria: Object,
    categoria: Object
  },
  data() {
    return {
      dialog_ativo: false,
      ressuprimento: 0,
      categorias_selecionadas: []
    };
  },
  validations: {
    categorias_selecionadas: {required},
    ressuprimento: {
      required,
      minValue: minValue(1)
    }
  },
  watch: {
    dialog_ativo(valor) {
      if(valor) {
        this.ressuprimento = this.detalhamento_categoria.ressuprimento_em_dias;
        this.categorias_selecionadas = [this.categoria.idcategoria];
      } else {
        setTimeout(() => {
          this.ressuprimento = 0;
          this.categorias_selecionadas = [];
          this.$v.$reset();
        }, 1000);
      }
    }
  },
  computed: {
    ...mapGetters({
      'callbackAtualizarGridCategorias': 'compraMateriaPrima/callbackAtualizarGridCategorias',
      'callbackAtualizarCardsTotais': 'compraMateriaPrima/callbackAtualizarCardsTotais',
      'callbackAtualizarDetalhesCategoria': 'compraMateriaPrima/callbackAtualizarDetalhesCategoria',
    })
  },
  methods: {
    getMensagensValidacao(campo) {
      if (!this.$v[campo].$dirty) return [];

      if ((this.$v[campo].$params.required !== undefined) && !this.$v[campo].required) {
        return  ["Campo Obrigatório."];
      }

      if ((this.$v[campo].$params.minValue !== undefined) && !this.$v[campo].minValue) {
        return  ["Informe um valor maior."];
      }

      return [];
    },
    alterarTempoRessuprimento() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      const params = {
        categorias: this.categorias_selecionadas,
        dias_ressuprimento: parseInt(this.ressuprimento),
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        alterarTempoRessuprimento(params)
          .then(() => {
            this.dialog_ativo = false;
            this.$emit('novo-ressuprimento_em_dias', this.ressuprimento);
            this.callbackAtualizarGridCategorias();
            this.callbackAtualizarCardsTotais();
            this.callbackAtualizarDetalhesCategoria();
          })
          .catch(logout)
      )
    }
  }
}
</script>

<style>

</style>
